export const KpiModelOverview = () => {
    return (
        <div className="space-y-3">
            <h3 className="text-base font-headline font-bold text-on-surface">Model Overview</h3>
            <div className="bg-surface-container rounded-md p-4 border border-outline-variant/20">
                <div className="flex items-start gap-2 mb-2">
                    <div
                        className="w-2 h-2 mt-1 rounded-full shrink-0"
                        style={{ backgroundColor: "var(--color-general-blue)" }}
                    ></div>
                    <p className="text-sm font-medium text-on-surface">
                        The model evaluates player performance based on a predefined set of core metrics.
                    </p>
                </div>
                <div className="flex items-start gap-2 mb-2 mt-4">
                    <div
                        className="w-2 h-2 mt-1 rounded-full shrink-0"
                        style={{ backgroundColor: "var(--color-general-blue)" }}
                    ></div>
                    <p className="text-sm font-medium text-on-surface">
                        The scoring system is calibrated so that an average performance across the entire database
                        yields a baseline score of approximately 60 points.
                    </p>
                </div>
                <div className="flex items-start gap-2 mt-4">
                    <div
                        className="w-2 h-2 mt-1 rounded-full shrink-0"
                        style={{ backgroundColor: "var(--color-general-blue)" }}
                    ></div>
                    <p className="text-sm font-medium text-on-surface">
                        A score of 100 points represents an absolute top-tier, elite performance.
                    </p>
                </div>
            </div>
        </div>
    );
};
